import styled from 'styled-components';
import { black10, white } from '../../../../libs/uiKit/globalStyledComponents';

export const StyledPrecalculationFormWrapper = styled.div`
	.textButton {
		margin-bottom: 1rem;
	}

	@media screen and (max-width: 767px) {
		.textButton {
			margin-bottom: 0.5rem;
		}
	}
`;
export const StyledPrecalculationFormCardWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 4rem;
	grid-row-gap: 4rem;

	@media screen and (max-width: 767px) {
		grid-template-columns: 1fr;
		grid-column-gap: 1.5rem;
		grid-row-gap: 1.5rem;
	}
`;

export const NewStyledPrecalculationFormCardWrapper = styled.div`
	display: grid;
	grid-template-columns: 2fr 1fr;
	grid-column-gap: 2rem;
	grid-row-gap: 4rem;
    max-width: 1250px;

	@media screen and (max-width: 767px) {
		grid-template-columns: 1fr;
		grid-column-gap: 1.5rem;
		grid-row-gap: 1.5rem;
	}
`;

export const StyledPrecalculationFormCard = styled.div`
	h2 {
		margin-bottom: 3rem;
	}

	.filledButton {
		margin-top: 4rem;
	}

	@media screen and (max-width: 767px) {
		h2 {
			margin-bottom: 2rem;
		}

		.filledButton {
			margin-top: 1.5rem;
		}
	}
`;

export const StyledDeclarationFormCard = styled.div`
	h2 {
		margin-bottom: 3rem;
	}

	@media screen and (max-width: 767px) {
		h2 {
			margin-bottom: 2rem;
		}
	}
`;

export const StyledPrecalculationForm = styled.div`
	background: ${white};
	padding: 4rem;
	width: calc(100% - 8rem);

	@media screen and (max-width: 767px) {
		padding: 2rem 1.5rem;
		width: calc(100% - 3rem);
	}
`;

export const StyledRisksFormWrapper = styled.div`
	h4 {
		margin: 2rem 0 2rem 0;
	}

	@media screen and (max-width: 767px) {
		h4 {
			margin: 4rem 0 2rem 0;
		}
	}
`;

export const StyledResultButtonsWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 2rem;
	grid-row-gap: 2rem;
	height: 7rem;

	@media screen and (max-width: 767px) {
		grid-template-columns: 1fr;
		grid-column-gap: 1.5rem;
		grid-row-gap: 0.5rem;
		margin-bottom: 2rem;
	}
`;
export const StyledBankCardsWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 2rem;
	grid-row-gap: 2rem;

	@media screen and (max-width: 767px) {
		grid-template-columns: 1fr;
		grid-column-gap: 1.5rem;
		grid-row-gap: 1.5rem;
	}
`;

export const NewStyledBankCardsWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-column-gap: 2rem;
	grid-row-gap: 2rem;

	@media screen and (max-width: 767px) {
		grid-template-columns: 1fr;
		grid-column-gap: 1.5rem;
		grid-row-gap: 1.5rem;
	}
`;

export const StyledBankCard = styled.div`
	padding: 2rem;
	background: ${white};

	@media screen and (max-width: 767px) {
		padding: 2rem 1.5rem;
	}
`;
export const NewStyledBankCard = styled.div`
	padding: 3rem;
	background: ${white};

	@media screen and (max-width: 767px) {
		padding: 2rem 1.5rem;
	}
`;
export const StyledBankCardHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const GlassEffect = styled.div`
    position: absolute;
    margin-left:-20px;
    margin-top: -20px;
    width: 400px;
    height: 200px;
    z-index: 1000;
    background: rgba(255, 255, 255, 0.25); /* Полупрозрачный белый */
    backdrop-filter: blur(10px); /* Размытие фона */
    -webkit-backdrop-filter: blur(10px); /* Для Safari */
`;

export const StyledDeclarationText = styled.div`
    font-size: 1.2rem;
    margin-top: 2rem;
    ul {
        list-style-type: disc;
        padding-left: 2rem;
        margin: 1rem 0;
    }
    li {
        margin-bottom: 1rem;
    }
    p {
        margin: 1rem 0;
    }
    max-height: 600px;
    overflow-y: auto;
`;

export const StyledHr = styled.div`
    border-bottom: 1px solid black;
    margin-bottom: 2rem;
    padding: 1rem 0;
`

export const StyledBankLogo = styled.div`
	width: 4rem;
	height: 4rem;
	position: relative;
	border-radius: 50%;
	border: 1px solid rgba(0, 0, 0, 0.2);
	img {
		position: absolute;
		width: 100%;
		height: 100%;
		text-indent: -9999px;
        border-radius: 50%;
	}
`;
export const StyledBankPremium = styled.div`
	margin: 2rem 0;
	padding: 2rem 0;
	border-top: 1px solid ${black10};
	border-bottom: 1px solid ${black10};
	h3 {
		margin-bottom: 1rem;
	}
	p {
		opacity: 0.5;
	}
`;
export const StyledBankTable = styled.div`
	margin-bottom: 3rem;
`;

export const StyledBankTableColumns = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-column-gap: 1rem;
	align-items: center;
	.precalculationRow {
		margin-top: 1.5rem;
		opacity: 0.5;
		white-space: nowrap;
	}
    .opa05 {
        opacity: 0.5;
    }
    .mt15 {
        margin-top: 1.5rem;
    }
    .right {
        text-align: right;
    }
`;

export const NewStyledBankTableColumns = styled.div`
	display: grid;
	grid-template-columns: 2fr 1fr;
    line-height: 2rem;
	grid-column-gap: 1rem;
    grid-row-gap: 0.5rem;
	align-items: center;
    margin-top: 2rem;
	.precalculationRow {
		margin-top: 1.5rem;
		opacity: 0.5;
		white-space: nowrap;
	}
    .opa05 {
        opacity: 0.5;
    }
    .gray {
        color: #808080;
    }
    .right {
        text-align: right;
    }
    .bold {
        font-weight: bold;
    }
    .header {
        margin-bottom: 0.8rem;
    }
    .pointer {
        cursor: pointer;
    }
`;

export const StyledLimitSumPanel = styled.div`
    width: 100%;
    background: #F5F5F5;
    font-size: 1.2rem;
    text-align: center;
    border-radius: 5px;
    vertical-align: middle;
    padding: 1rem 0;
    color: #808080;
    span {
        color: black;
    }
    margin-bottom: 1rem;
`;

export const StyledDashedLine = styled.div`
    height: 1px;
    background: linear-gradient(
            to right,
            #E5E5E5 0%, #E5E5E5 40%,
            white 40%, white 100%
    );
    background-size: 5px 2px; /* 2px черный + 3px белый = 5px */
    background-repeat: repeat-x;
`;

export const StyledBorrowerNeedOsm = styled.div`
	display: flex;
	align-items: center;
	margin-top: 1.5rem;
	> p {
		opacity: 0.5;
	}
	> .iconButton {
		margin-left: 0.5rem;
	}
	svg {
		width: 1.5rem;
		height: 1.5rem;
	}
`;

export const StyledText4Oms = styled.span`
  color: white;
  background-color: #41B6E6;
  font-size: 1.2rem;
  padding: 0.4rem 0.7rem;
  border-radius: 10px;
  font-weight: normal;
  margin-left: 1rem;
`;

export const StyledText4OmsWrapper = styled.div`
  margin-top: -1rem;
  margin-bottom: 1.5rem;
`;

export const StyledSubjectHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	@media screen and (max-width: 767px) {
		margin-bottom: 2rem;
	}
`;

export const StyledCrossedPremiumHeader = styled.span`
    font-size: 1.4rem;
    line-height: 5rem;
    font-weight: 500;
    text-decoration: line-through;
    color: #CCCCCC;
`;